import { DefaultService, type Order } from "@/api/SolarCloudApi";
import { v4 as uuid } from "uuid";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { QueryConfig } from "@/lib/react-query";

export default function getNewOrderOptions(uuid: string) {
  return queryOptions({
    queryKey: ["myOrder", uuid],
    queryFn: () => getNewOrder(uuid),
    staleTime: 1000 * 60 * 5,
    enabled: !!uuid,
    retry: 1,
  });
}

async function getNewOrder(uuid: string) {
  const response = await DefaultService.newOrderGet(uuid) as Order;
  return response;
}

type useGetNewOrderOptions = {
  uuid?: string;
  queryConfig?: QueryConfig<typeof getNewOrderOptions>;
};

export function useNewOrder({ uuid, queryConfig }: useGetNewOrderOptions = {}) {
  return useQuery({
    ...getNewOrderOptions(uuid ?? ""),
    ...queryConfig,
  });
}
